// @generated by protobuf-ts 2.11.1 with parameter server_generic,client_generic,generate_dependencies
// @generated from protobuf file "sites/v1/service.proto" (package "sites.v1", syntax proto3)
// tslint:disable
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { WireType } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { FieldMask } from "../../google/protobuf/field_mask.js";
import { PaginationResponse } from "../../common/v1/common.js";
import { PaginationRequest } from "../../common/v1/common.js";
/**
 * Enums
 *
 * @generated from protobuf enum sites.v1.PhaseType
 */
export var PhaseType;
(function (PhaseType) {
    /**
     * @generated from protobuf enum value: PHASE_TYPE_UNSPECIFIED = 0;
     */
    PhaseType[PhaseType["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from protobuf enum value: PHASE_TYPE_SINGLE = 1;
     */
    PhaseType[PhaseType["SINGLE"] = 1] = "SINGLE";
    /**
     * @generated from protobuf enum value: PHASE_TYPE_THREE = 2;
     */
    PhaseType[PhaseType["THREE"] = 2] = "THREE";
})(PhaseType || (PhaseType = {}));
// @generated message type with reflection information, may provide speed optimized methods
class Tso$Type extends MessageType {
    constructor() {
        super("sites.v1.Tso", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "country_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "currency", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "area", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "created_at", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 8, name: "updated_at", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 9, name: "deleted_at", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 10, name: "timezone", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        message.name = "";
        message.countryCode = "";
        message.currency = "";
        message.createdAt = 0n;
        message.updatedAt = 0n;
        message.deletedAt = 0n;
        message.timezone = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* string country_code */ 3:
                    message.countryCode = reader.string();
                    break;
                case /* string currency */ 4:
                    message.currency = reader.string();
                    break;
                case /* optional string area */ 5:
                    message.area = reader.string();
                    break;
                case /* uint64 created_at */ 7:
                    message.createdAt = reader.uint64().toBigInt();
                    break;
                case /* uint64 updated_at */ 8:
                    message.updatedAt = reader.uint64().toBigInt();
                    break;
                case /* uint64 deleted_at */ 9:
                    message.deletedAt = reader.uint64().toBigInt();
                    break;
                case /* string timezone */ 10:
                    message.timezone = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* string country_code = 3; */
        if (message.countryCode !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.countryCode);
        /* string currency = 4; */
        if (message.currency !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.currency);
        /* optional string area = 5; */
        if (message.area !== undefined)
            writer.tag(5, WireType.LengthDelimited).string(message.area);
        /* uint64 created_at = 7; */
        if (message.createdAt !== 0n)
            writer.tag(7, WireType.Varint).uint64(message.createdAt);
        /* uint64 updated_at = 8; */
        if (message.updatedAt !== 0n)
            writer.tag(8, WireType.Varint).uint64(message.updatedAt);
        /* uint64 deleted_at = 9; */
        if (message.deletedAt !== 0n)
            writer.tag(9, WireType.Varint).uint64(message.deletedAt);
        /* string timezone = 10; */
        if (message.timezone !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.timezone);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message sites.v1.Tso
 */
export const Tso = new Tso$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Dso$Type extends MessageType {
    constructor() {
        super("sites.v1.Dso", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "created_at", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 9, name: "updated_at", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 11, name: "area", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "country_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "eia_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 14, name: "is_manual", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 15, name: "dso_circuit", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 16, name: "tso_substation", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 17, name: "external_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        message.name = "";
        message.createdAt = 0n;
        message.updatedAt = 0n;
        message.area = "";
        message.countryCode = "";
        message.eiaId = "";
        message.isManual = false;
        message.dsoCircuit = "";
        message.tsoSubstation = "";
        message.externalId = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* uint64 created_at */ 8:
                    message.createdAt = reader.uint64().toBigInt();
                    break;
                case /* uint64 updated_at */ 9:
                    message.updatedAt = reader.uint64().toBigInt();
                    break;
                case /* string area */ 11:
                    message.area = reader.string();
                    break;
                case /* string country_code */ 12:
                    message.countryCode = reader.string();
                    break;
                case /* string eia_id */ 13:
                    message.eiaId = reader.string();
                    break;
                case /* bool is_manual */ 14:
                    message.isManual = reader.bool();
                    break;
                case /* string dso_circuit */ 15:
                    message.dsoCircuit = reader.string();
                    break;
                case /* string tso_substation */ 16:
                    message.tsoSubstation = reader.string();
                    break;
                case /* string external_id */ 17:
                    message.externalId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* uint64 created_at = 8; */
        if (message.createdAt !== 0n)
            writer.tag(8, WireType.Varint).uint64(message.createdAt);
        /* uint64 updated_at = 9; */
        if (message.updatedAt !== 0n)
            writer.tag(9, WireType.Varint).uint64(message.updatedAt);
        /* string area = 11; */
        if (message.area !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.area);
        /* string country_code = 12; */
        if (message.countryCode !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.countryCode);
        /* string eia_id = 13; */
        if (message.eiaId !== "")
            writer.tag(13, WireType.LengthDelimited).string(message.eiaId);
        /* bool is_manual = 14; */
        if (message.isManual !== false)
            writer.tag(14, WireType.Varint).bool(message.isManual);
        /* string dso_circuit = 15; */
        if (message.dsoCircuit !== "")
            writer.tag(15, WireType.LengthDelimited).string(message.dsoCircuit);
        /* string tso_substation = 16; */
        if (message.tsoSubstation !== "")
            writer.tag(16, WireType.LengthDelimited).string(message.tsoSubstation);
        /* string external_id = 17; */
        if (message.externalId !== "")
            writer.tag(17, WireType.LengthDelimited).string(message.externalId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message sites.v1.Dso
 */
export const Dso = new Dso$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Site$Type extends MessageType {
    constructor() {
        super("sites.v1.Site", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "street", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "locality", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "region", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "country_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "postal_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "timezone", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "latitude", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 11, name: "longitude", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 12, name: "instant_charge", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 14, name: "created_at", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 15, name: "updated_at", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 16, name: "deleted_at", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 17, name: "delivery_points", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => DeliveryPoint }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        message.name = "";
        message.street = "";
        message.locality = "";
        message.region = "";
        message.countryCode = "";
        message.postalCode = "";
        message.timezone = "";
        message.latitude = 0;
        message.longitude = 0;
        message.instantCharge = false;
        message.createdAt = 0n;
        message.updatedAt = 0n;
        message.deletedAt = 0n;
        message.deliveryPoints = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* string street */ 4:
                    message.street = reader.string();
                    break;
                case /* string locality */ 5:
                    message.locality = reader.string();
                    break;
                case /* string region */ 6:
                    message.region = reader.string();
                    break;
                case /* string country_code */ 7:
                    message.countryCode = reader.string();
                    break;
                case /* string postal_code */ 8:
                    message.postalCode = reader.string();
                    break;
                case /* string timezone */ 9:
                    message.timezone = reader.string();
                    break;
                case /* double latitude */ 10:
                    message.latitude = reader.double();
                    break;
                case /* double longitude */ 11:
                    message.longitude = reader.double();
                    break;
                case /* bool instant_charge */ 12:
                    message.instantCharge = reader.bool();
                    break;
                case /* uint64 created_at */ 14:
                    message.createdAt = reader.uint64().toBigInt();
                    break;
                case /* uint64 updated_at */ 15:
                    message.updatedAt = reader.uint64().toBigInt();
                    break;
                case /* uint64 deleted_at */ 16:
                    message.deletedAt = reader.uint64().toBigInt();
                    break;
                case /* repeated sites.v1.DeliveryPoint delivery_points */ 17:
                    message.deliveryPoints.push(DeliveryPoint.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* string street = 4; */
        if (message.street !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.street);
        /* string locality = 5; */
        if (message.locality !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.locality);
        /* string region = 6; */
        if (message.region !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.region);
        /* string country_code = 7; */
        if (message.countryCode !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.countryCode);
        /* string postal_code = 8; */
        if (message.postalCode !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.postalCode);
        /* string timezone = 9; */
        if (message.timezone !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.timezone);
        /* double latitude = 10; */
        if (message.latitude !== 0)
            writer.tag(10, WireType.Bit64).double(message.latitude);
        /* double longitude = 11; */
        if (message.longitude !== 0)
            writer.tag(11, WireType.Bit64).double(message.longitude);
        /* bool instant_charge = 12; */
        if (message.instantCharge !== false)
            writer.tag(12, WireType.Varint).bool(message.instantCharge);
        /* uint64 created_at = 14; */
        if (message.createdAt !== 0n)
            writer.tag(14, WireType.Varint).uint64(message.createdAt);
        /* uint64 updated_at = 15; */
        if (message.updatedAt !== 0n)
            writer.tag(15, WireType.Varint).uint64(message.updatedAt);
        /* uint64 deleted_at = 16; */
        if (message.deletedAt !== 0n)
            writer.tag(16, WireType.Varint).uint64(message.deletedAt);
        /* repeated sites.v1.DeliveryPoint delivery_points = 17; */
        for (let i = 0; i < message.deliveryPoints.length; i++)
            DeliveryPoint.internalBinaryWrite(message.deliveryPoints[i], writer.tag(17, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message sites.v1.Site
 */
export const Site = new Site$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeliveryPoint$Type extends MessageType {
    constructor() {
        super("sites.v1.DeliveryPoint", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "max_charge_power", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "max_discharge_power", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "reference_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "phases", kind: "enum", T: () => ["sites.v1.PhaseType", PhaseType, "PHASE_TYPE_"] },
            { no: 6, name: "site_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "subscribed_charge_power", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "subscribed_discharge_power", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 9, name: "street", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "locality", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "region", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "country_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "postal_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 14, name: "created_at", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 15, name: "updated_at", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 16, name: "deleted_at", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 17, name: "site", kind: "message", T: () => Site },
            { no: 18, name: "circuits", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Circuit }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        message.maxChargePower = 0;
        message.maxDischargePower = 0;
        message.referenceNumber = "";
        message.phases = 0;
        message.siteId = "";
        message.subscribedChargePower = 0;
        message.subscribedDischargePower = 0;
        message.street = "";
        message.locality = "";
        message.region = "";
        message.countryCode = "";
        message.postalCode = "";
        message.createdAt = 0n;
        message.updatedAt = 0n;
        message.deletedAt = 0n;
        message.circuits = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* int32 max_charge_power */ 2:
                    message.maxChargePower = reader.int32();
                    break;
                case /* int32 max_discharge_power */ 3:
                    message.maxDischargePower = reader.int32();
                    break;
                case /* string reference_number */ 4:
                    message.referenceNumber = reader.string();
                    break;
                case /* sites.v1.PhaseType phases */ 5:
                    message.phases = reader.int32();
                    break;
                case /* string site_id */ 6:
                    message.siteId = reader.string();
                    break;
                case /* int32 subscribed_charge_power */ 7:
                    message.subscribedChargePower = reader.int32();
                    break;
                case /* int32 subscribed_discharge_power */ 8:
                    message.subscribedDischargePower = reader.int32();
                    break;
                case /* string street */ 9:
                    message.street = reader.string();
                    break;
                case /* string locality */ 10:
                    message.locality = reader.string();
                    break;
                case /* string region */ 11:
                    message.region = reader.string();
                    break;
                case /* string country_code */ 12:
                    message.countryCode = reader.string();
                    break;
                case /* string postal_code */ 13:
                    message.postalCode = reader.string();
                    break;
                case /* uint64 created_at */ 14:
                    message.createdAt = reader.uint64().toBigInt();
                    break;
                case /* uint64 updated_at */ 15:
                    message.updatedAt = reader.uint64().toBigInt();
                    break;
                case /* uint64 deleted_at */ 16:
                    message.deletedAt = reader.uint64().toBigInt();
                    break;
                case /* sites.v1.Site site */ 17:
                    message.site = Site.internalBinaryRead(reader, reader.uint32(), options, message.site);
                    break;
                case /* repeated sites.v1.Circuit circuits */ 18:
                    message.circuits.push(Circuit.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* int32 max_charge_power = 2; */
        if (message.maxChargePower !== 0)
            writer.tag(2, WireType.Varint).int32(message.maxChargePower);
        /* int32 max_discharge_power = 3; */
        if (message.maxDischargePower !== 0)
            writer.tag(3, WireType.Varint).int32(message.maxDischargePower);
        /* string reference_number = 4; */
        if (message.referenceNumber !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.referenceNumber);
        /* sites.v1.PhaseType phases = 5; */
        if (message.phases !== 0)
            writer.tag(5, WireType.Varint).int32(message.phases);
        /* string site_id = 6; */
        if (message.siteId !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.siteId);
        /* int32 subscribed_charge_power = 7; */
        if (message.subscribedChargePower !== 0)
            writer.tag(7, WireType.Varint).int32(message.subscribedChargePower);
        /* int32 subscribed_discharge_power = 8; */
        if (message.subscribedDischargePower !== 0)
            writer.tag(8, WireType.Varint).int32(message.subscribedDischargePower);
        /* string street = 9; */
        if (message.street !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.street);
        /* string locality = 10; */
        if (message.locality !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.locality);
        /* string region = 11; */
        if (message.region !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.region);
        /* string country_code = 12; */
        if (message.countryCode !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.countryCode);
        /* string postal_code = 13; */
        if (message.postalCode !== "")
            writer.tag(13, WireType.LengthDelimited).string(message.postalCode);
        /* uint64 created_at = 14; */
        if (message.createdAt !== 0n)
            writer.tag(14, WireType.Varint).uint64(message.createdAt);
        /* uint64 updated_at = 15; */
        if (message.updatedAt !== 0n)
            writer.tag(15, WireType.Varint).uint64(message.updatedAt);
        /* uint64 deleted_at = 16; */
        if (message.deletedAt !== 0n)
            writer.tag(16, WireType.Varint).uint64(message.deletedAt);
        /* sites.v1.Site site = 17; */
        if (message.site)
            Site.internalBinaryWrite(message.site, writer.tag(17, WireType.LengthDelimited).fork(), options).join();
        /* repeated sites.v1.Circuit circuits = 18; */
        for (let i = 0; i < message.circuits.length; i++)
            Circuit.internalBinaryWrite(message.circuits[i], writer.tag(18, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message sites.v1.DeliveryPoint
 */
export const DeliveryPoint = new DeliveryPoint$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Circuit$Type extends MessageType {
    constructor() {
        super("sites.v1.Circuit", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "max_charge_power", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "max_discharge_power", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "phases", kind: "enum", T: () => ["sites.v1.PhaseType", PhaseType, "PHASE_TYPE_"] },
            { no: 6, name: "connected_phase", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "active", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 8, name: "delivery_point_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "created_at", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 10, name: "updated_at", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 11, name: "deleted_at", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 12, name: "delivery_point", kind: "message", T: () => DeliveryPoint },
            { no: 13, name: "child_nodes", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => CircuitNode },
            { no: 14, name: "parent_nodes", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => CircuitNode },
            { no: 15, name: "circuit_devices", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => CircuitDevice }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        message.name = "";
        message.maxChargePower = 0;
        message.maxDischargePower = 0;
        message.phases = 0;
        message.connectedPhase = "";
        message.active = false;
        message.deliveryPointId = "";
        message.createdAt = 0n;
        message.updatedAt = 0n;
        message.deletedAt = 0n;
        message.childNodes = [];
        message.parentNodes = [];
        message.circuitDevices = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* int32 max_charge_power */ 3:
                    message.maxChargePower = reader.int32();
                    break;
                case /* int32 max_discharge_power */ 4:
                    message.maxDischargePower = reader.int32();
                    break;
                case /* sites.v1.PhaseType phases */ 5:
                    message.phases = reader.int32();
                    break;
                case /* string connected_phase */ 6:
                    message.connectedPhase = reader.string();
                    break;
                case /* bool active */ 7:
                    message.active = reader.bool();
                    break;
                case /* string delivery_point_id */ 8:
                    message.deliveryPointId = reader.string();
                    break;
                case /* uint64 created_at */ 9:
                    message.createdAt = reader.uint64().toBigInt();
                    break;
                case /* uint64 updated_at */ 10:
                    message.updatedAt = reader.uint64().toBigInt();
                    break;
                case /* uint64 deleted_at */ 11:
                    message.deletedAt = reader.uint64().toBigInt();
                    break;
                case /* sites.v1.DeliveryPoint delivery_point */ 12:
                    message.deliveryPoint = DeliveryPoint.internalBinaryRead(reader, reader.uint32(), options, message.deliveryPoint);
                    break;
                case /* repeated sites.v1.CircuitNode child_nodes */ 13:
                    message.childNodes.push(CircuitNode.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated sites.v1.CircuitNode parent_nodes */ 14:
                    message.parentNodes.push(CircuitNode.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated sites.v1.CircuitDevice circuit_devices */ 15:
                    message.circuitDevices.push(CircuitDevice.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* int32 max_charge_power = 3; */
        if (message.maxChargePower !== 0)
            writer.tag(3, WireType.Varint).int32(message.maxChargePower);
        /* int32 max_discharge_power = 4; */
        if (message.maxDischargePower !== 0)
            writer.tag(4, WireType.Varint).int32(message.maxDischargePower);
        /* sites.v1.PhaseType phases = 5; */
        if (message.phases !== 0)
            writer.tag(5, WireType.Varint).int32(message.phases);
        /* string connected_phase = 6; */
        if (message.connectedPhase !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.connectedPhase);
        /* bool active = 7; */
        if (message.active !== false)
            writer.tag(7, WireType.Varint).bool(message.active);
        /* string delivery_point_id = 8; */
        if (message.deliveryPointId !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.deliveryPointId);
        /* uint64 created_at = 9; */
        if (message.createdAt !== 0n)
            writer.tag(9, WireType.Varint).uint64(message.createdAt);
        /* uint64 updated_at = 10; */
        if (message.updatedAt !== 0n)
            writer.tag(10, WireType.Varint).uint64(message.updatedAt);
        /* uint64 deleted_at = 11; */
        if (message.deletedAt !== 0n)
            writer.tag(11, WireType.Varint).uint64(message.deletedAt);
        /* sites.v1.DeliveryPoint delivery_point = 12; */
        if (message.deliveryPoint)
            DeliveryPoint.internalBinaryWrite(message.deliveryPoint, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* repeated sites.v1.CircuitNode child_nodes = 13; */
        for (let i = 0; i < message.childNodes.length; i++)
            CircuitNode.internalBinaryWrite(message.childNodes[i], writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* repeated sites.v1.CircuitNode parent_nodes = 14; */
        for (let i = 0; i < message.parentNodes.length; i++)
            CircuitNode.internalBinaryWrite(message.parentNodes[i], writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        /* repeated sites.v1.CircuitDevice circuit_devices = 15; */
        for (let i = 0; i < message.circuitDevices.length; i++)
            CircuitDevice.internalBinaryWrite(message.circuitDevices[i], writer.tag(15, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message sites.v1.Circuit
 */
export const Circuit = new Circuit$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CircuitNode$Type extends MessageType {
    constructor() {
        super("sites.v1.CircuitNode", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "parent_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "child_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "created_at", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 5, name: "updated_at", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 6, name: "parent_circuit", kind: "message", T: () => Circuit },
            { no: 7, name: "child_circuit", kind: "message", T: () => Circuit }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        message.parentId = "";
        message.childId = "";
        message.createdAt = 0n;
        message.updatedAt = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string parent_id */ 2:
                    message.parentId = reader.string();
                    break;
                case /* string child_id */ 3:
                    message.childId = reader.string();
                    break;
                case /* uint64 created_at */ 4:
                    message.createdAt = reader.uint64().toBigInt();
                    break;
                case /* uint64 updated_at */ 5:
                    message.updatedAt = reader.uint64().toBigInt();
                    break;
                case /* sites.v1.Circuit parent_circuit */ 6:
                    message.parentCircuit = Circuit.internalBinaryRead(reader, reader.uint32(), options, message.parentCircuit);
                    break;
                case /* sites.v1.Circuit child_circuit */ 7:
                    message.childCircuit = Circuit.internalBinaryRead(reader, reader.uint32(), options, message.childCircuit);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string parent_id = 2; */
        if (message.parentId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.parentId);
        /* string child_id = 3; */
        if (message.childId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.childId);
        /* uint64 created_at = 4; */
        if (message.createdAt !== 0n)
            writer.tag(4, WireType.Varint).uint64(message.createdAt);
        /* uint64 updated_at = 5; */
        if (message.updatedAt !== 0n)
            writer.tag(5, WireType.Varint).uint64(message.updatedAt);
        /* sites.v1.Circuit parent_circuit = 6; */
        if (message.parentCircuit)
            Circuit.internalBinaryWrite(message.parentCircuit, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* sites.v1.Circuit child_circuit = 7; */
        if (message.childCircuit)
            Circuit.internalBinaryWrite(message.childCircuit, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message sites.v1.CircuitNode
 */
export const CircuitNode = new CircuitNode$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CircuitDevice$Type extends MessageType {
    constructor() {
        super("sites.v1.CircuitDevice", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "device_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "circuit_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "connected_phase", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "first_phase_position", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "priority", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "created_at", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 8, name: "updated_at", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 9, name: "deleted_at", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 10, name: "circuit", kind: "message", T: () => Circuit }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        message.deviceId = "";
        message.circuitId = "";
        message.connectedPhase = "";
        message.firstPhasePosition = "";
        message.priority = 0;
        message.createdAt = 0n;
        message.updatedAt = 0n;
        message.deletedAt = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string device_id */ 2:
                    message.deviceId = reader.string();
                    break;
                case /* string circuit_id */ 3:
                    message.circuitId = reader.string();
                    break;
                case /* string connected_phase */ 4:
                    message.connectedPhase = reader.string();
                    break;
                case /* string first_phase_position */ 5:
                    message.firstPhasePosition = reader.string();
                    break;
                case /* int32 priority */ 6:
                    message.priority = reader.int32();
                    break;
                case /* uint64 created_at */ 7:
                    message.createdAt = reader.uint64().toBigInt();
                    break;
                case /* uint64 updated_at */ 8:
                    message.updatedAt = reader.uint64().toBigInt();
                    break;
                case /* uint64 deleted_at */ 9:
                    message.deletedAt = reader.uint64().toBigInt();
                    break;
                case /* sites.v1.Circuit circuit */ 10:
                    message.circuit = Circuit.internalBinaryRead(reader, reader.uint32(), options, message.circuit);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string device_id = 2; */
        if (message.deviceId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.deviceId);
        /* string circuit_id = 3; */
        if (message.circuitId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.circuitId);
        /* string connected_phase = 4; */
        if (message.connectedPhase !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.connectedPhase);
        /* string first_phase_position = 5; */
        if (message.firstPhasePosition !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.firstPhasePosition);
        /* int32 priority = 6; */
        if (message.priority !== 0)
            writer.tag(6, WireType.Varint).int32(message.priority);
        /* uint64 created_at = 7; */
        if (message.createdAt !== 0n)
            writer.tag(7, WireType.Varint).uint64(message.createdAt);
        /* uint64 updated_at = 8; */
        if (message.updatedAt !== 0n)
            writer.tag(8, WireType.Varint).uint64(message.updatedAt);
        /* uint64 deleted_at = 9; */
        if (message.deletedAt !== 0n)
            writer.tag(9, WireType.Varint).uint64(message.deletedAt);
        /* sites.v1.Circuit circuit = 10; */
        if (message.circuit)
            Circuit.internalBinaryWrite(message.circuit, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message sites.v1.CircuitDevice
 */
export const CircuitDevice = new CircuitDevice$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TsoFilter$Type extends MessageType {
    constructor() {
        super("sites.v1.TsoFilter", [
            { no: 1, name: "names", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "country_codes", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "currencies", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "include_deleted", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.names = [];
        message.countryCodes = [];
        message.currencies = [];
        message.includeDeleted = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string names */ 1:
                    message.names.push(reader.string());
                    break;
                case /* repeated string country_codes */ 2:
                    message.countryCodes.push(reader.string());
                    break;
                case /* repeated string currencies */ 3:
                    message.currencies.push(reader.string());
                    break;
                case /* bool include_deleted */ 4:
                    message.includeDeleted = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated string names = 1; */
        for (let i = 0; i < message.names.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.names[i]);
        /* repeated string country_codes = 2; */
        for (let i = 0; i < message.countryCodes.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.countryCodes[i]);
        /* repeated string currencies = 3; */
        for (let i = 0; i < message.currencies.length; i++)
            writer.tag(3, WireType.LengthDelimited).string(message.currencies[i]);
        /* bool include_deleted = 4; */
        if (message.includeDeleted !== false)
            writer.tag(4, WireType.Varint).bool(message.includeDeleted);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message sites.v1.TsoFilter
 */
export const TsoFilter = new TsoFilter$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListTsosRequest$Type extends MessageType {
    constructor() {
        super("sites.v1.ListTsosRequest", [
            { no: 1, name: "filter", kind: "message", T: () => TsoFilter },
            { no: 2, name: "pagination", kind: "message", T: () => PaginationRequest }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* sites.v1.TsoFilter filter */ 1:
                    message.filter = TsoFilter.internalBinaryRead(reader, reader.uint32(), options, message.filter);
                    break;
                case /* common.v1.PaginationRequest pagination */ 2:
                    message.pagination = PaginationRequest.internalBinaryRead(reader, reader.uint32(), options, message.pagination);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* sites.v1.TsoFilter filter = 1; */
        if (message.filter)
            TsoFilter.internalBinaryWrite(message.filter, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* common.v1.PaginationRequest pagination = 2; */
        if (message.pagination)
            PaginationRequest.internalBinaryWrite(message.pagination, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message sites.v1.ListTsosRequest
 */
export const ListTsosRequest = new ListTsosRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListTsosResponse$Type extends MessageType {
    constructor() {
        super("sites.v1.ListTsosResponse", [
            { no: 1, name: "tsos", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Tso },
            { no: 2, name: "pagination", kind: "message", T: () => PaginationResponse }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.tsos = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated sites.v1.Tso tsos */ 1:
                    message.tsos.push(Tso.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* common.v1.PaginationResponse pagination */ 2:
                    message.pagination = PaginationResponse.internalBinaryRead(reader, reader.uint32(), options, message.pagination);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated sites.v1.Tso tsos = 1; */
        for (let i = 0; i < message.tsos.length; i++)
            Tso.internalBinaryWrite(message.tsos[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* common.v1.PaginationResponse pagination = 2; */
        if (message.pagination)
            PaginationResponse.internalBinaryWrite(message.pagination, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message sites.v1.ListTsosResponse
 */
export const ListTsosResponse = new ListTsosResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateTsoRequest$Type extends MessageType {
    constructor() {
        super("sites.v1.CreateTsoRequest", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "country_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "currency", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "area", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "timezone", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.name = "";
        message.countryCode = "";
        message.currency = "";
        message.timezone = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string name */ 1:
                    message.name = reader.string();
                    break;
                case /* string country_code */ 2:
                    message.countryCode = reader.string();
                    break;
                case /* string currency */ 3:
                    message.currency = reader.string();
                    break;
                case /* optional string area */ 4:
                    message.area = reader.string();
                    break;
                case /* string timezone */ 6:
                    message.timezone = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string name = 1; */
        if (message.name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        /* string country_code = 2; */
        if (message.countryCode !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.countryCode);
        /* string currency = 3; */
        if (message.currency !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.currency);
        /* optional string area = 4; */
        if (message.area !== undefined)
            writer.tag(4, WireType.LengthDelimited).string(message.area);
        /* string timezone = 6; */
        if (message.timezone !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.timezone);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message sites.v1.CreateTsoRequest
 */
export const CreateTsoRequest = new CreateTsoRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateTsoResponse$Type extends MessageType {
    constructor() {
        super("sites.v1.CreateTsoResponse", [
            { no: 1, name: "tso", kind: "message", T: () => Tso }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* sites.v1.Tso tso */ 1:
                    message.tso = Tso.internalBinaryRead(reader, reader.uint32(), options, message.tso);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* sites.v1.Tso tso = 1; */
        if (message.tso)
            Tso.internalBinaryWrite(message.tso, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message sites.v1.CreateTsoResponse
 */
export const CreateTsoResponse = new CreateTsoResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetTsoRequest$Type extends MessageType {
    constructor() {
        super("sites.v1.GetTsoRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message sites.v1.GetTsoRequest
 */
export const GetTsoRequest = new GetTsoRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetTsoResponse$Type extends MessageType {
    constructor() {
        super("sites.v1.GetTsoResponse", [
            { no: 1, name: "tso", kind: "message", T: () => Tso }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* sites.v1.Tso tso */ 1:
                    message.tso = Tso.internalBinaryRead(reader, reader.uint32(), options, message.tso);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* sites.v1.Tso tso = 1; */
        if (message.tso)
            Tso.internalBinaryWrite(message.tso, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message sites.v1.GetTsoResponse
 */
export const GetTsoResponse = new GetTsoResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateTsoRequest$Type extends MessageType {
    constructor() {
        super("sites.v1.UpdateTsoRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "country_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "currency", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "area", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "update_mask", kind: "message", T: () => FieldMask },
            { no: 8, name: "timezone", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        message.name = "";
        message.countryCode = "";
        message.currency = "";
        message.timezone = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* string country_code */ 3:
                    message.countryCode = reader.string();
                    break;
                case /* string currency */ 4:
                    message.currency = reader.string();
                    break;
                case /* optional string area */ 5:
                    message.area = reader.string();
                    break;
                case /* google.protobuf.FieldMask update_mask */ 7:
                    message.updateMask = FieldMask.internalBinaryRead(reader, reader.uint32(), options, message.updateMask);
                    break;
                case /* string timezone */ 8:
                    message.timezone = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* string country_code = 3; */
        if (message.countryCode !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.countryCode);
        /* string currency = 4; */
        if (message.currency !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.currency);
        /* optional string area = 5; */
        if (message.area !== undefined)
            writer.tag(5, WireType.LengthDelimited).string(message.area);
        /* google.protobuf.FieldMask update_mask = 7; */
        if (message.updateMask)
            FieldMask.internalBinaryWrite(message.updateMask, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* string timezone = 8; */
        if (message.timezone !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.timezone);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message sites.v1.UpdateTsoRequest
 */
export const UpdateTsoRequest = new UpdateTsoRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateTsoResponse$Type extends MessageType {
    constructor() {
        super("sites.v1.UpdateTsoResponse", [
            { no: 1, name: "tso", kind: "message", T: () => Tso }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* sites.v1.Tso tso */ 1:
                    message.tso = Tso.internalBinaryRead(reader, reader.uint32(), options, message.tso);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* sites.v1.Tso tso = 1; */
        if (message.tso)
            Tso.internalBinaryWrite(message.tso, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message sites.v1.UpdateTsoResponse
 */
export const UpdateTsoResponse = new UpdateTsoResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteTsoRequest$Type extends MessageType {
    constructor() {
        super("sites.v1.DeleteTsoRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "permanent", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        message.permanent = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* bool permanent */ 2:
                    message.permanent = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* bool permanent = 2; */
        if (message.permanent !== false)
            writer.tag(2, WireType.Varint).bool(message.permanent);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message sites.v1.DeleteTsoRequest
 */
export const DeleteTsoRequest = new DeleteTsoRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteTsoResponse$Type extends MessageType {
    constructor() {
        super("sites.v1.DeleteTsoResponse", []);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message sites.v1.DeleteTsoResponse
 */
export const DeleteTsoResponse = new DeleteTsoResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RestoreTsoRequest$Type extends MessageType {
    constructor() {
        super("sites.v1.RestoreTsoRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message sites.v1.RestoreTsoRequest
 */
export const RestoreTsoRequest = new RestoreTsoRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RestoreTsoResponse$Type extends MessageType {
    constructor() {
        super("sites.v1.RestoreTsoResponse", []);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message sites.v1.RestoreTsoResponse
 */
export const RestoreTsoResponse = new RestoreTsoResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListDsosRequest$Type extends MessageType {
    constructor() {
        super("sites.v1.ListDsosRequest", [
            { no: 3, name: "pagination", kind: "message", T: () => PaginationRequest },
            { no: 4, name: "country_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "area", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.countryCode = "";
        message.area = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* common.v1.PaginationRequest pagination */ 3:
                    message.pagination = PaginationRequest.internalBinaryRead(reader, reader.uint32(), options, message.pagination);
                    break;
                case /* string country_code */ 4:
                    message.countryCode = reader.string();
                    break;
                case /* string area */ 5:
                    message.area = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* common.v1.PaginationRequest pagination = 3; */
        if (message.pagination)
            PaginationRequest.internalBinaryWrite(message.pagination, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* string country_code = 4; */
        if (message.countryCode !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.countryCode);
        /* string area = 5; */
        if (message.area !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.area);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message sites.v1.ListDsosRequest
 */
export const ListDsosRequest = new ListDsosRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListDsosResponse$Type extends MessageType {
    constructor() {
        super("sites.v1.ListDsosResponse", [
            { no: 1, name: "dsos", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Dso },
            { no: 2, name: "pagination", kind: "message", T: () => PaginationResponse }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.dsos = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated sites.v1.Dso dsos */ 1:
                    message.dsos.push(Dso.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* common.v1.PaginationResponse pagination */ 2:
                    message.pagination = PaginationResponse.internalBinaryRead(reader, reader.uint32(), options, message.pagination);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated sites.v1.Dso dsos = 1; */
        for (let i = 0; i < message.dsos.length; i++)
            Dso.internalBinaryWrite(message.dsos[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* common.v1.PaginationResponse pagination = 2; */
        if (message.pagination)
            PaginationResponse.internalBinaryWrite(message.pagination, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message sites.v1.ListDsosResponse
 */
export const ListDsosResponse = new ListDsosResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateDsoRequest$Type extends MessageType {
    constructor() {
        super("sites.v1.CreateDsoRequest", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "area", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "country_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "eia_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "is_manual", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 11, name: "dso_circuit", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "tso_substation", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "external_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.name = "";
        message.area = "";
        message.countryCode = "";
        message.eiaId = "";
        message.isManual = false;
        message.dsoCircuit = "";
        message.tsoSubstation = "";
        message.externalId = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string name */ 1:
                    message.name = reader.string();
                    break;
                case /* string area */ 7:
                    message.area = reader.string();
                    break;
                case /* string country_code */ 8:
                    message.countryCode = reader.string();
                    break;
                case /* string eia_id */ 9:
                    message.eiaId = reader.string();
                    break;
                case /* bool is_manual */ 10:
                    message.isManual = reader.bool();
                    break;
                case /* string dso_circuit */ 11:
                    message.dsoCircuit = reader.string();
                    break;
                case /* string tso_substation */ 12:
                    message.tsoSubstation = reader.string();
                    break;
                case /* string external_id */ 13:
                    message.externalId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string name = 1; */
        if (message.name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        /* string area = 7; */
        if (message.area !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.area);
        /* string country_code = 8; */
        if (message.countryCode !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.countryCode);
        /* string eia_id = 9; */
        if (message.eiaId !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.eiaId);
        /* bool is_manual = 10; */
        if (message.isManual !== false)
            writer.tag(10, WireType.Varint).bool(message.isManual);
        /* string dso_circuit = 11; */
        if (message.dsoCircuit !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.dsoCircuit);
        /* string tso_substation = 12; */
        if (message.tsoSubstation !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.tsoSubstation);
        /* string external_id = 13; */
        if (message.externalId !== "")
            writer.tag(13, WireType.LengthDelimited).string(message.externalId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message sites.v1.CreateDsoRequest
 */
export const CreateDsoRequest = new CreateDsoRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateDsoResponse$Type extends MessageType {
    constructor() {
        super("sites.v1.CreateDsoResponse", [
            { no: 1, name: "dso", kind: "message", T: () => Dso }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* sites.v1.Dso dso */ 1:
                    message.dso = Dso.internalBinaryRead(reader, reader.uint32(), options, message.dso);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* sites.v1.Dso dso = 1; */
        if (message.dso)
            Dso.internalBinaryWrite(message.dso, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message sites.v1.CreateDsoResponse
 */
export const CreateDsoResponse = new CreateDsoResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetDsoRequest$Type extends MessageType {
    constructor() {
        super("sites.v1.GetDsoRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message sites.v1.GetDsoRequest
 */
export const GetDsoRequest = new GetDsoRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetDsoResponse$Type extends MessageType {
    constructor() {
        super("sites.v1.GetDsoResponse", [
            { no: 1, name: "dso", kind: "message", T: () => Dso }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* sites.v1.Dso dso */ 1:
                    message.dso = Dso.internalBinaryRead(reader, reader.uint32(), options, message.dso);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* sites.v1.Dso dso = 1; */
        if (message.dso)
            Dso.internalBinaryWrite(message.dso, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message sites.v1.GetDsoResponse
 */
export const GetDsoResponse = new GetDsoResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateDsoRequest$Type extends MessageType {
    constructor() {
        super("sites.v1.UpdateDsoRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "update_mask", kind: "message", T: () => FieldMask },
            { no: 9, name: "area", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "country_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "eia_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "is_manual", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 13, name: "dso_circuit", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 14, name: "tso_substation", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 15, name: "external_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        message.name = "";
        message.area = "";
        message.countryCode = "";
        message.eiaId = "";
        message.isManual = false;
        message.dsoCircuit = "";
        message.tsoSubstation = "";
        message.externalId = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* google.protobuf.FieldMask update_mask */ 8:
                    message.updateMask = FieldMask.internalBinaryRead(reader, reader.uint32(), options, message.updateMask);
                    break;
                case /* string area */ 9:
                    message.area = reader.string();
                    break;
                case /* string country_code */ 10:
                    message.countryCode = reader.string();
                    break;
                case /* string eia_id */ 11:
                    message.eiaId = reader.string();
                    break;
                case /* bool is_manual */ 12:
                    message.isManual = reader.bool();
                    break;
                case /* string dso_circuit */ 13:
                    message.dsoCircuit = reader.string();
                    break;
                case /* string tso_substation */ 14:
                    message.tsoSubstation = reader.string();
                    break;
                case /* string external_id */ 15:
                    message.externalId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* google.protobuf.FieldMask update_mask = 8; */
        if (message.updateMask)
            FieldMask.internalBinaryWrite(message.updateMask, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* string area = 9; */
        if (message.area !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.area);
        /* string country_code = 10; */
        if (message.countryCode !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.countryCode);
        /* string eia_id = 11; */
        if (message.eiaId !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.eiaId);
        /* bool is_manual = 12; */
        if (message.isManual !== false)
            writer.tag(12, WireType.Varint).bool(message.isManual);
        /* string dso_circuit = 13; */
        if (message.dsoCircuit !== "")
            writer.tag(13, WireType.LengthDelimited).string(message.dsoCircuit);
        /* string tso_substation = 14; */
        if (message.tsoSubstation !== "")
            writer.tag(14, WireType.LengthDelimited).string(message.tsoSubstation);
        /* string external_id = 15; */
        if (message.externalId !== "")
            writer.tag(15, WireType.LengthDelimited).string(message.externalId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message sites.v1.UpdateDsoRequest
 */
export const UpdateDsoRequest = new UpdateDsoRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateDsoResponse$Type extends MessageType {
    constructor() {
        super("sites.v1.UpdateDsoResponse", [
            { no: 1, name: "dso", kind: "message", T: () => Dso }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* sites.v1.Dso dso */ 1:
                    message.dso = Dso.internalBinaryRead(reader, reader.uint32(), options, message.dso);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* sites.v1.Dso dso = 1; */
        if (message.dso)
            Dso.internalBinaryWrite(message.dso, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message sites.v1.UpdateDsoResponse
 */
export const UpdateDsoResponse = new UpdateDsoResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteDsoRequest$Type extends MessageType {
    constructor() {
        super("sites.v1.DeleteDsoRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message sites.v1.DeleteDsoRequest
 */
export const DeleteDsoRequest = new DeleteDsoRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteDsoResponse$Type extends MessageType {
    constructor() {
        super("sites.v1.DeleteDsoResponse", [
            { no: 1, name: "success", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.success = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool success */ 1:
                    message.success = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool success = 1; */
        if (message.success !== false)
            writer.tag(1, WireType.Varint).bool(message.success);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message sites.v1.DeleteDsoResponse
 */
export const DeleteDsoResponse = new DeleteDsoResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListSitesRequest$Type extends MessageType {
    constructor() {
        super("sites.v1.ListSitesRequest", [
            { no: 2, name: "country_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "region", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "instant_charge", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "pagination", kind: "message", T: () => PaginationRequest },
            { no: 7, name: "customer_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "tenant_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.countryCode = "";
        message.region = "";
        message.instantCharge = false;
        message.customerIds = [];
        message.tenantId = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string country_code */ 2:
                    message.countryCode = reader.string();
                    break;
                case /* string region */ 3:
                    message.region = reader.string();
                    break;
                case /* bool instant_charge */ 5:
                    message.instantCharge = reader.bool();
                    break;
                case /* common.v1.PaginationRequest pagination */ 6:
                    message.pagination = PaginationRequest.internalBinaryRead(reader, reader.uint32(), options, message.pagination);
                    break;
                case /* repeated string customer_ids */ 7:
                    message.customerIds.push(reader.string());
                    break;
                case /* string tenant_id */ 8:
                    message.tenantId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string country_code = 2; */
        if (message.countryCode !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.countryCode);
        /* string region = 3; */
        if (message.region !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.region);
        /* bool instant_charge = 5; */
        if (message.instantCharge !== false)
            writer.tag(5, WireType.Varint).bool(message.instantCharge);
        /* common.v1.PaginationRequest pagination = 6; */
        if (message.pagination)
            PaginationRequest.internalBinaryWrite(message.pagination, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* repeated string customer_ids = 7; */
        for (let i = 0; i < message.customerIds.length; i++)
            writer.tag(7, WireType.LengthDelimited).string(message.customerIds[i]);
        /* string tenant_id = 8; */
        if (message.tenantId !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.tenantId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message sites.v1.ListSitesRequest
 */
export const ListSitesRequest = new ListSitesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListSitesResponse$Type extends MessageType {
    constructor() {
        super("sites.v1.ListSitesResponse", [
            { no: 1, name: "sites", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Site },
            { no: 2, name: "pagination", kind: "message", T: () => PaginationResponse }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.sites = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated sites.v1.Site sites */ 1:
                    message.sites.push(Site.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* common.v1.PaginationResponse pagination */ 2:
                    message.pagination = PaginationResponse.internalBinaryRead(reader, reader.uint32(), options, message.pagination);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated sites.v1.Site sites = 1; */
        for (let i = 0; i < message.sites.length; i++)
            Site.internalBinaryWrite(message.sites[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* common.v1.PaginationResponse pagination = 2; */
        if (message.pagination)
            PaginationResponse.internalBinaryWrite(message.pagination, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message sites.v1.ListSitesResponse
 */
export const ListSitesResponse = new ListSitesResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateSiteRequest$Type extends MessageType {
    constructor() {
        super("sites.v1.CreateSiteRequest", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "street", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "locality", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "region", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "country_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "postal_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "timezone", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "latitude", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 10, name: "longitude", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 11, name: "instant_charge", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.name = "";
        message.street = "";
        message.locality = "";
        message.region = "";
        message.countryCode = "";
        message.postalCode = "";
        message.timezone = "";
        message.latitude = 0;
        message.longitude = 0;
        message.instantCharge = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string name */ 1:
                    message.name = reader.string();
                    break;
                case /* string street */ 3:
                    message.street = reader.string();
                    break;
                case /* string locality */ 4:
                    message.locality = reader.string();
                    break;
                case /* string region */ 5:
                    message.region = reader.string();
                    break;
                case /* string country_code */ 6:
                    message.countryCode = reader.string();
                    break;
                case /* string postal_code */ 7:
                    message.postalCode = reader.string();
                    break;
                case /* string timezone */ 8:
                    message.timezone = reader.string();
                    break;
                case /* double latitude */ 9:
                    message.latitude = reader.double();
                    break;
                case /* double longitude */ 10:
                    message.longitude = reader.double();
                    break;
                case /* bool instant_charge */ 11:
                    message.instantCharge = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string name = 1; */
        if (message.name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        /* string street = 3; */
        if (message.street !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.street);
        /* string locality = 4; */
        if (message.locality !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.locality);
        /* string region = 5; */
        if (message.region !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.region);
        /* string country_code = 6; */
        if (message.countryCode !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.countryCode);
        /* string postal_code = 7; */
        if (message.postalCode !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.postalCode);
        /* string timezone = 8; */
        if (message.timezone !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.timezone);
        /* double latitude = 9; */
        if (message.latitude !== 0)
            writer.tag(9, WireType.Bit64).double(message.latitude);
        /* double longitude = 10; */
        if (message.longitude !== 0)
            writer.tag(10, WireType.Bit64).double(message.longitude);
        /* bool instant_charge = 11; */
        if (message.instantCharge !== false)
            writer.tag(11, WireType.Varint).bool(message.instantCharge);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message sites.v1.CreateSiteRequest
 */
export const CreateSiteRequest = new CreateSiteRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateSiteResponse$Type extends MessageType {
    constructor() {
        super("sites.v1.CreateSiteResponse", [
            { no: 1, name: "site", kind: "message", T: () => Site }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* sites.v1.Site site */ 1:
                    message.site = Site.internalBinaryRead(reader, reader.uint32(), options, message.site);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* sites.v1.Site site = 1; */
        if (message.site)
            Site.internalBinaryWrite(message.site, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message sites.v1.CreateSiteResponse
 */
export const CreateSiteResponse = new CreateSiteResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSiteRequest$Type extends MessageType {
    constructor() {
        super("sites.v1.GetSiteRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "include_delivery_points", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        message.includeDeliveryPoints = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* bool include_delivery_points */ 2:
                    message.includeDeliveryPoints = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* bool include_delivery_points = 2; */
        if (message.includeDeliveryPoints !== false)
            writer.tag(2, WireType.Varint).bool(message.includeDeliveryPoints);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message sites.v1.GetSiteRequest
 */
export const GetSiteRequest = new GetSiteRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSiteResponse$Type extends MessageType {
    constructor() {
        super("sites.v1.GetSiteResponse", [
            { no: 1, name: "site", kind: "message", T: () => Site }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* sites.v1.Site site */ 1:
                    message.site = Site.internalBinaryRead(reader, reader.uint32(), options, message.site);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* sites.v1.Site site = 1; */
        if (message.site)
            Site.internalBinaryWrite(message.site, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message sites.v1.GetSiteResponse
 */
export const GetSiteResponse = new GetSiteResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateSiteRequest$Type extends MessageType {
    constructor() {
        super("sites.v1.UpdateSiteRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "street", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "locality", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "region", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "country_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "postal_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "timezone", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "latitude", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 11, name: "longitude", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 12, name: "instant_charge", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 14, name: "update_mask", kind: "message", T: () => FieldMask }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        message.name = "";
        message.street = "";
        message.locality = "";
        message.region = "";
        message.countryCode = "";
        message.postalCode = "";
        message.timezone = "";
        message.latitude = 0;
        message.longitude = 0;
        message.instantCharge = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* string street */ 4:
                    message.street = reader.string();
                    break;
                case /* string locality */ 5:
                    message.locality = reader.string();
                    break;
                case /* string region */ 6:
                    message.region = reader.string();
                    break;
                case /* string country_code */ 7:
                    message.countryCode = reader.string();
                    break;
                case /* string postal_code */ 8:
                    message.postalCode = reader.string();
                    break;
                case /* string timezone */ 9:
                    message.timezone = reader.string();
                    break;
                case /* double latitude */ 10:
                    message.latitude = reader.double();
                    break;
                case /* double longitude */ 11:
                    message.longitude = reader.double();
                    break;
                case /* bool instant_charge */ 12:
                    message.instantCharge = reader.bool();
                    break;
                case /* google.protobuf.FieldMask update_mask */ 14:
                    message.updateMask = FieldMask.internalBinaryRead(reader, reader.uint32(), options, message.updateMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* string street = 4; */
        if (message.street !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.street);
        /* string locality = 5; */
        if (message.locality !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.locality);
        /* string region = 6; */
        if (message.region !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.region);
        /* string country_code = 7; */
        if (message.countryCode !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.countryCode);
        /* string postal_code = 8; */
        if (message.postalCode !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.postalCode);
        /* string timezone = 9; */
        if (message.timezone !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.timezone);
        /* double latitude = 10; */
        if (message.latitude !== 0)
            writer.tag(10, WireType.Bit64).double(message.latitude);
        /* double longitude = 11; */
        if (message.longitude !== 0)
            writer.tag(11, WireType.Bit64).double(message.longitude);
        /* bool instant_charge = 12; */
        if (message.instantCharge !== false)
            writer.tag(12, WireType.Varint).bool(message.instantCharge);
        /* google.protobuf.FieldMask update_mask = 14; */
        if (message.updateMask)
            FieldMask.internalBinaryWrite(message.updateMask, writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message sites.v1.UpdateSiteRequest
 */
export const UpdateSiteRequest = new UpdateSiteRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateSiteResponse$Type extends MessageType {
    constructor() {
        super("sites.v1.UpdateSiteResponse", [
            { no: 1, name: "site", kind: "message", T: () => Site }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* sites.v1.Site site */ 1:
                    message.site = Site.internalBinaryRead(reader, reader.uint32(), options, message.site);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* sites.v1.Site site = 1; */
        if (message.site)
            Site.internalBinaryWrite(message.site, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message sites.v1.UpdateSiteResponse
 */
export const UpdateSiteResponse = new UpdateSiteResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteSiteRequest$Type extends MessageType {
    constructor() {
        super("sites.v1.DeleteSiteRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message sites.v1.DeleteSiteRequest
 */
export const DeleteSiteRequest = new DeleteSiteRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteSiteResponse$Type extends MessageType {
    constructor() {
        super("sites.v1.DeleteSiteResponse", [
            { no: 1, name: "success", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.success = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool success */ 1:
                    message.success = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool success = 1; */
        if (message.success !== false)
            writer.tag(1, WireType.Varint).bool(message.success);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message sites.v1.DeleteSiteResponse
 */
export const DeleteSiteResponse = new DeleteSiteResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListDeliveryPointsRequest$Type extends MessageType {
    constructor() {
        super("sites.v1.ListDeliveryPointsRequest", [
            { no: 1, name: "site_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "phases", kind: "enum", T: () => ["sites.v1.PhaseType", PhaseType, "PHASE_TYPE_"] },
            { no: 3, name: "pagination", kind: "message", T: () => PaginationRequest }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.siteId = "";
        message.phases = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string site_id */ 1:
                    message.siteId = reader.string();
                    break;
                case /* sites.v1.PhaseType phases */ 2:
                    message.phases = reader.int32();
                    break;
                case /* common.v1.PaginationRequest pagination */ 3:
                    message.pagination = PaginationRequest.internalBinaryRead(reader, reader.uint32(), options, message.pagination);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string site_id = 1; */
        if (message.siteId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.siteId);
        /* sites.v1.PhaseType phases = 2; */
        if (message.phases !== 0)
            writer.tag(2, WireType.Varint).int32(message.phases);
        /* common.v1.PaginationRequest pagination = 3; */
        if (message.pagination)
            PaginationRequest.internalBinaryWrite(message.pagination, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message sites.v1.ListDeliveryPointsRequest
 */
export const ListDeliveryPointsRequest = new ListDeliveryPointsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListDeliveryPointsResponse$Type extends MessageType {
    constructor() {
        super("sites.v1.ListDeliveryPointsResponse", [
            { no: 1, name: "delivery_points", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => DeliveryPoint },
            { no: 2, name: "pagination", kind: "message", T: () => PaginationResponse }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.deliveryPoints = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated sites.v1.DeliveryPoint delivery_points */ 1:
                    message.deliveryPoints.push(DeliveryPoint.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* common.v1.PaginationResponse pagination */ 2:
                    message.pagination = PaginationResponse.internalBinaryRead(reader, reader.uint32(), options, message.pagination);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated sites.v1.DeliveryPoint delivery_points = 1; */
        for (let i = 0; i < message.deliveryPoints.length; i++)
            DeliveryPoint.internalBinaryWrite(message.deliveryPoints[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* common.v1.PaginationResponse pagination = 2; */
        if (message.pagination)
            PaginationResponse.internalBinaryWrite(message.pagination, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message sites.v1.ListDeliveryPointsResponse
 */
export const ListDeliveryPointsResponse = new ListDeliveryPointsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateDeliveryPointRequest$Type extends MessageType {
    constructor() {
        super("sites.v1.CreateDeliveryPointRequest", [
            { no: 1, name: "max_charge_power", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "max_discharge_power", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reference_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "phases", kind: "enum", T: () => ["sites.v1.PhaseType", PhaseType, "PHASE_TYPE_"] },
            { no: 5, name: "site_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "subscribed_charge_power", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "subscribed_discharge_power", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "street", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "locality", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "region", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "country_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "postal_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.maxChargePower = 0;
        message.maxDischargePower = 0;
        message.referenceNumber = "";
        message.phases = 0;
        message.siteId = "";
        message.subscribedChargePower = 0;
        message.subscribedDischargePower = 0;
        message.street = "";
        message.locality = "";
        message.region = "";
        message.countryCode = "";
        message.postalCode = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 max_charge_power */ 1:
                    message.maxChargePower = reader.int32();
                    break;
                case /* int32 max_discharge_power */ 2:
                    message.maxDischargePower = reader.int32();
                    break;
                case /* string reference_number */ 3:
                    message.referenceNumber = reader.string();
                    break;
                case /* sites.v1.PhaseType phases */ 4:
                    message.phases = reader.int32();
                    break;
                case /* string site_id */ 5:
                    message.siteId = reader.string();
                    break;
                case /* int32 subscribed_charge_power */ 6:
                    message.subscribedChargePower = reader.int32();
                    break;
                case /* int32 subscribed_discharge_power */ 7:
                    message.subscribedDischargePower = reader.int32();
                    break;
                case /* string street */ 8:
                    message.street = reader.string();
                    break;
                case /* string locality */ 9:
                    message.locality = reader.string();
                    break;
                case /* string region */ 10:
                    message.region = reader.string();
                    break;
                case /* string country_code */ 11:
                    message.countryCode = reader.string();
                    break;
                case /* string postal_code */ 12:
                    message.postalCode = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 max_charge_power = 1; */
        if (message.maxChargePower !== 0)
            writer.tag(1, WireType.Varint).int32(message.maxChargePower);
        /* int32 max_discharge_power = 2; */
        if (message.maxDischargePower !== 0)
            writer.tag(2, WireType.Varint).int32(message.maxDischargePower);
        /* string reference_number = 3; */
        if (message.referenceNumber !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.referenceNumber);
        /* sites.v1.PhaseType phases = 4; */
        if (message.phases !== 0)
            writer.tag(4, WireType.Varint).int32(message.phases);
        /* string site_id = 5; */
        if (message.siteId !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.siteId);
        /* int32 subscribed_charge_power = 6; */
        if (message.subscribedChargePower !== 0)
            writer.tag(6, WireType.Varint).int32(message.subscribedChargePower);
        /* int32 subscribed_discharge_power = 7; */
        if (message.subscribedDischargePower !== 0)
            writer.tag(7, WireType.Varint).int32(message.subscribedDischargePower);
        /* string street = 8; */
        if (message.street !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.street);
        /* string locality = 9; */
        if (message.locality !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.locality);
        /* string region = 10; */
        if (message.region !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.region);
        /* string country_code = 11; */
        if (message.countryCode !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.countryCode);
        /* string postal_code = 12; */
        if (message.postalCode !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.postalCode);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message sites.v1.CreateDeliveryPointRequest
 */
export const CreateDeliveryPointRequest = new CreateDeliveryPointRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateDeliveryPointResponse$Type extends MessageType {
    constructor() {
        super("sites.v1.CreateDeliveryPointResponse", [
            { no: 1, name: "delivery_point", kind: "message", T: () => DeliveryPoint }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* sites.v1.DeliveryPoint delivery_point */ 1:
                    message.deliveryPoint = DeliveryPoint.internalBinaryRead(reader, reader.uint32(), options, message.deliveryPoint);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* sites.v1.DeliveryPoint delivery_point = 1; */
        if (message.deliveryPoint)
            DeliveryPoint.internalBinaryWrite(message.deliveryPoint, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message sites.v1.CreateDeliveryPointResponse
 */
export const CreateDeliveryPointResponse = new CreateDeliveryPointResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetDeliveryPointRequest$Type extends MessageType {
    constructor() {
        super("sites.v1.GetDeliveryPointRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "include_circuits", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        message.includeCircuits = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* bool include_circuits */ 2:
                    message.includeCircuits = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* bool include_circuits = 2; */
        if (message.includeCircuits !== false)
            writer.tag(2, WireType.Varint).bool(message.includeCircuits);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message sites.v1.GetDeliveryPointRequest
 */
export const GetDeliveryPointRequest = new GetDeliveryPointRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetDeliveryPointResponse$Type extends MessageType {
    constructor() {
        super("sites.v1.GetDeliveryPointResponse", [
            { no: 1, name: "delivery_point", kind: "message", T: () => DeliveryPoint }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* sites.v1.DeliveryPoint delivery_point */ 1:
                    message.deliveryPoint = DeliveryPoint.internalBinaryRead(reader, reader.uint32(), options, message.deliveryPoint);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* sites.v1.DeliveryPoint delivery_point = 1; */
        if (message.deliveryPoint)
            DeliveryPoint.internalBinaryWrite(message.deliveryPoint, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message sites.v1.GetDeliveryPointResponse
 */
export const GetDeliveryPointResponse = new GetDeliveryPointResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateDeliveryPointRequest$Type extends MessageType {
    constructor() {
        super("sites.v1.UpdateDeliveryPointRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "max_charge_power", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "max_discharge_power", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "reference_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "phases", kind: "enum", T: () => ["sites.v1.PhaseType", PhaseType, "PHASE_TYPE_"] },
            { no: 6, name: "subscribed_charge_power", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "subscribed_discharge_power", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "street", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "locality", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "region", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "country_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "postal_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "update_mask", kind: "message", T: () => FieldMask }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        message.maxChargePower = 0;
        message.maxDischargePower = 0;
        message.referenceNumber = "";
        message.phases = 0;
        message.subscribedChargePower = 0;
        message.subscribedDischargePower = 0;
        message.street = "";
        message.locality = "";
        message.region = "";
        message.countryCode = "";
        message.postalCode = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* int32 max_charge_power */ 2:
                    message.maxChargePower = reader.int32();
                    break;
                case /* int32 max_discharge_power */ 3:
                    message.maxDischargePower = reader.int32();
                    break;
                case /* string reference_number */ 4:
                    message.referenceNumber = reader.string();
                    break;
                case /* sites.v1.PhaseType phases */ 5:
                    message.phases = reader.int32();
                    break;
                case /* int32 subscribed_charge_power */ 6:
                    message.subscribedChargePower = reader.int32();
                    break;
                case /* int32 subscribed_discharge_power */ 7:
                    message.subscribedDischargePower = reader.int32();
                    break;
                case /* string street */ 8:
                    message.street = reader.string();
                    break;
                case /* string locality */ 9:
                    message.locality = reader.string();
                    break;
                case /* string region */ 10:
                    message.region = reader.string();
                    break;
                case /* string country_code */ 11:
                    message.countryCode = reader.string();
                    break;
                case /* string postal_code */ 12:
                    message.postalCode = reader.string();
                    break;
                case /* google.protobuf.FieldMask update_mask */ 13:
                    message.updateMask = FieldMask.internalBinaryRead(reader, reader.uint32(), options, message.updateMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* int32 max_charge_power = 2; */
        if (message.maxChargePower !== 0)
            writer.tag(2, WireType.Varint).int32(message.maxChargePower);
        /* int32 max_discharge_power = 3; */
        if (message.maxDischargePower !== 0)
            writer.tag(3, WireType.Varint).int32(message.maxDischargePower);
        /* string reference_number = 4; */
        if (message.referenceNumber !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.referenceNumber);
        /* sites.v1.PhaseType phases = 5; */
        if (message.phases !== 0)
            writer.tag(5, WireType.Varint).int32(message.phases);
        /* int32 subscribed_charge_power = 6; */
        if (message.subscribedChargePower !== 0)
            writer.tag(6, WireType.Varint).int32(message.subscribedChargePower);
        /* int32 subscribed_discharge_power = 7; */
        if (message.subscribedDischargePower !== 0)
            writer.tag(7, WireType.Varint).int32(message.subscribedDischargePower);
        /* string street = 8; */
        if (message.street !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.street);
        /* string locality = 9; */
        if (message.locality !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.locality);
        /* string region = 10; */
        if (message.region !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.region);
        /* string country_code = 11; */
        if (message.countryCode !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.countryCode);
        /* string postal_code = 12; */
        if (message.postalCode !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.postalCode);
        /* google.protobuf.FieldMask update_mask = 13; */
        if (message.updateMask)
            FieldMask.internalBinaryWrite(message.updateMask, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message sites.v1.UpdateDeliveryPointRequest
 */
export const UpdateDeliveryPointRequest = new UpdateDeliveryPointRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateDeliveryPointResponse$Type extends MessageType {
    constructor() {
        super("sites.v1.UpdateDeliveryPointResponse", [
            { no: 1, name: "delivery_point", kind: "message", T: () => DeliveryPoint }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* sites.v1.DeliveryPoint delivery_point */ 1:
                    message.deliveryPoint = DeliveryPoint.internalBinaryRead(reader, reader.uint32(), options, message.deliveryPoint);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* sites.v1.DeliveryPoint delivery_point = 1; */
        if (message.deliveryPoint)
            DeliveryPoint.internalBinaryWrite(message.deliveryPoint, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message sites.v1.UpdateDeliveryPointResponse
 */
export const UpdateDeliveryPointResponse = new UpdateDeliveryPointResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteDeliveryPointRequest$Type extends MessageType {
    constructor() {
        super("sites.v1.DeleteDeliveryPointRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message sites.v1.DeleteDeliveryPointRequest
 */
export const DeleteDeliveryPointRequest = new DeleteDeliveryPointRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteDeliveryPointResponse$Type extends MessageType {
    constructor() {
        super("sites.v1.DeleteDeliveryPointResponse", [
            { no: 1, name: "success", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.success = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool success */ 1:
                    message.success = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool success = 1; */
        if (message.success !== false)
            writer.tag(1, WireType.Varint).bool(message.success);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message sites.v1.DeleteDeliveryPointResponse
 */
export const DeleteDeliveryPointResponse = new DeleteDeliveryPointResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListCircuitsRequest$Type extends MessageType {
    constructor() {
        super("sites.v1.ListCircuitsRequest", [
            { no: 1, name: "delivery_point_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "active", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "phases", kind: "enum", T: () => ["sites.v1.PhaseType", PhaseType, "PHASE_TYPE_"] },
            { no: 4, name: "pagination", kind: "message", T: () => PaginationRequest }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.deliveryPointId = "";
        message.phases = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string delivery_point_id */ 1:
                    message.deliveryPointId = reader.string();
                    break;
                case /* optional bool active */ 2:
                    message.active = reader.bool();
                    break;
                case /* sites.v1.PhaseType phases */ 3:
                    message.phases = reader.int32();
                    break;
                case /* common.v1.PaginationRequest pagination */ 4:
                    message.pagination = PaginationRequest.internalBinaryRead(reader, reader.uint32(), options, message.pagination);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string delivery_point_id = 1; */
        if (message.deliveryPointId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.deliveryPointId);
        /* optional bool active = 2; */
        if (message.active !== undefined)
            writer.tag(2, WireType.Varint).bool(message.active);
        /* sites.v1.PhaseType phases = 3; */
        if (message.phases !== 0)
            writer.tag(3, WireType.Varint).int32(message.phases);
        /* common.v1.PaginationRequest pagination = 4; */
        if (message.pagination)
            PaginationRequest.internalBinaryWrite(message.pagination, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message sites.v1.ListCircuitsRequest
 */
export const ListCircuitsRequest = new ListCircuitsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListCircuitsResponse$Type extends MessageType {
    constructor() {
        super("sites.v1.ListCircuitsResponse", [
            { no: 1, name: "circuits", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Circuit },
            { no: 2, name: "pagination", kind: "message", T: () => PaginationResponse }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.circuits = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated sites.v1.Circuit circuits */ 1:
                    message.circuits.push(Circuit.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* common.v1.PaginationResponse pagination */ 2:
                    message.pagination = PaginationResponse.internalBinaryRead(reader, reader.uint32(), options, message.pagination);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated sites.v1.Circuit circuits = 1; */
        for (let i = 0; i < message.circuits.length; i++)
            Circuit.internalBinaryWrite(message.circuits[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* common.v1.PaginationResponse pagination = 2; */
        if (message.pagination)
            PaginationResponse.internalBinaryWrite(message.pagination, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message sites.v1.ListCircuitsResponse
 */
export const ListCircuitsResponse = new ListCircuitsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateCircuitRequest$Type extends MessageType {
    constructor() {
        super("sites.v1.CreateCircuitRequest", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "max_charge_power", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "max_discharge_power", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "phases", kind: "enum", T: () => ["sites.v1.PhaseType", PhaseType, "PHASE_TYPE_"] },
            { no: 5, name: "connected_phase", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "active", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 7, name: "delivery_point_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.name = "";
        message.maxChargePower = 0;
        message.maxDischargePower = 0;
        message.phases = 0;
        message.connectedPhase = "";
        message.active = false;
        message.deliveryPointId = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string name */ 1:
                    message.name = reader.string();
                    break;
                case /* int32 max_charge_power */ 2:
                    message.maxChargePower = reader.int32();
                    break;
                case /* int32 max_discharge_power */ 3:
                    message.maxDischargePower = reader.int32();
                    break;
                case /* sites.v1.PhaseType phases */ 4:
                    message.phases = reader.int32();
                    break;
                case /* string connected_phase */ 5:
                    message.connectedPhase = reader.string();
                    break;
                case /* bool active */ 6:
                    message.active = reader.bool();
                    break;
                case /* string delivery_point_id */ 7:
                    message.deliveryPointId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string name = 1; */
        if (message.name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        /* int32 max_charge_power = 2; */
        if (message.maxChargePower !== 0)
            writer.tag(2, WireType.Varint).int32(message.maxChargePower);
        /* int32 max_discharge_power = 3; */
        if (message.maxDischargePower !== 0)
            writer.tag(3, WireType.Varint).int32(message.maxDischargePower);
        /* sites.v1.PhaseType phases = 4; */
        if (message.phases !== 0)
            writer.tag(4, WireType.Varint).int32(message.phases);
        /* string connected_phase = 5; */
        if (message.connectedPhase !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.connectedPhase);
        /* bool active = 6; */
        if (message.active !== false)
            writer.tag(6, WireType.Varint).bool(message.active);
        /* string delivery_point_id = 7; */
        if (message.deliveryPointId !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.deliveryPointId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message sites.v1.CreateCircuitRequest
 */
export const CreateCircuitRequest = new CreateCircuitRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateCircuitResponse$Type extends MessageType {
    constructor() {
        super("sites.v1.CreateCircuitResponse", [
            { no: 1, name: "circuit", kind: "message", T: () => Circuit }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* sites.v1.Circuit circuit */ 1:
                    message.circuit = Circuit.internalBinaryRead(reader, reader.uint32(), options, message.circuit);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* sites.v1.Circuit circuit = 1; */
        if (message.circuit)
            Circuit.internalBinaryWrite(message.circuit, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message sites.v1.CreateCircuitResponse
 */
export const CreateCircuitResponse = new CreateCircuitResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetCircuitRequest$Type extends MessageType {
    constructor() {
        super("sites.v1.GetCircuitRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "include_nodes", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "include_devices", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        message.includeNodes = false;
        message.includeDevices = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* bool include_nodes */ 2:
                    message.includeNodes = reader.bool();
                    break;
                case /* bool include_devices */ 3:
                    message.includeDevices = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* bool include_nodes = 2; */
        if (message.includeNodes !== false)
            writer.tag(2, WireType.Varint).bool(message.includeNodes);
        /* bool include_devices = 3; */
        if (message.includeDevices !== false)
            writer.tag(3, WireType.Varint).bool(message.includeDevices);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message sites.v1.GetCircuitRequest
 */
export const GetCircuitRequest = new GetCircuitRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetCircuitResponse$Type extends MessageType {
    constructor() {
        super("sites.v1.GetCircuitResponse", [
            { no: 1, name: "circuit", kind: "message", T: () => Circuit }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* sites.v1.Circuit circuit */ 1:
                    message.circuit = Circuit.internalBinaryRead(reader, reader.uint32(), options, message.circuit);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* sites.v1.Circuit circuit = 1; */
        if (message.circuit)
            Circuit.internalBinaryWrite(message.circuit, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message sites.v1.GetCircuitResponse
 */
export const GetCircuitResponse = new GetCircuitResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCircuitRequest$Type extends MessageType {
    constructor() {
        super("sites.v1.UpdateCircuitRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "max_charge_power", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "max_discharge_power", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "phases", kind: "enum", T: () => ["sites.v1.PhaseType", PhaseType, "PHASE_TYPE_"] },
            { no: 6, name: "connected_phase", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "active", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 8, name: "update_mask", kind: "message", T: () => FieldMask }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        message.name = "";
        message.maxChargePower = 0;
        message.maxDischargePower = 0;
        message.phases = 0;
        message.connectedPhase = "";
        message.active = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* int32 max_charge_power */ 3:
                    message.maxChargePower = reader.int32();
                    break;
                case /* int32 max_discharge_power */ 4:
                    message.maxDischargePower = reader.int32();
                    break;
                case /* sites.v1.PhaseType phases */ 5:
                    message.phases = reader.int32();
                    break;
                case /* string connected_phase */ 6:
                    message.connectedPhase = reader.string();
                    break;
                case /* bool active */ 7:
                    message.active = reader.bool();
                    break;
                case /* google.protobuf.FieldMask update_mask */ 8:
                    message.updateMask = FieldMask.internalBinaryRead(reader, reader.uint32(), options, message.updateMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* int32 max_charge_power = 3; */
        if (message.maxChargePower !== 0)
            writer.tag(3, WireType.Varint).int32(message.maxChargePower);
        /* int32 max_discharge_power = 4; */
        if (message.maxDischargePower !== 0)
            writer.tag(4, WireType.Varint).int32(message.maxDischargePower);
        /* sites.v1.PhaseType phases = 5; */
        if (message.phases !== 0)
            writer.tag(5, WireType.Varint).int32(message.phases);
        /* string connected_phase = 6; */
        if (message.connectedPhase !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.connectedPhase);
        /* bool active = 7; */
        if (message.active !== false)
            writer.tag(7, WireType.Varint).bool(message.active);
        /* google.protobuf.FieldMask update_mask = 8; */
        if (message.updateMask)
            FieldMask.internalBinaryWrite(message.updateMask, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message sites.v1.UpdateCircuitRequest
 */
export const UpdateCircuitRequest = new UpdateCircuitRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCircuitResponse$Type extends MessageType {
    constructor() {
        super("sites.v1.UpdateCircuitResponse", [
            { no: 1, name: "circuit", kind: "message", T: () => Circuit }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* sites.v1.Circuit circuit */ 1:
                    message.circuit = Circuit.internalBinaryRead(reader, reader.uint32(), options, message.circuit);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* sites.v1.Circuit circuit = 1; */
        if (message.circuit)
            Circuit.internalBinaryWrite(message.circuit, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message sites.v1.UpdateCircuitResponse
 */
export const UpdateCircuitResponse = new UpdateCircuitResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteCircuitRequest$Type extends MessageType {
    constructor() {
        super("sites.v1.DeleteCircuitRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message sites.v1.DeleteCircuitRequest
 */
export const DeleteCircuitRequest = new DeleteCircuitRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteCircuitResponse$Type extends MessageType {
    constructor() {
        super("sites.v1.DeleteCircuitResponse", [
            { no: 1, name: "success", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.success = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool success */ 1:
                    message.success = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool success = 1; */
        if (message.success !== false)
            writer.tag(1, WireType.Varint).bool(message.success);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message sites.v1.DeleteCircuitResponse
 */
export const DeleteCircuitResponse = new DeleteCircuitResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListCircuitNodesRequest$Type extends MessageType {
    constructor() {
        super("sites.v1.ListCircuitNodesRequest", [
            { no: 1, name: "parent_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "child_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "pagination", kind: "message", T: () => PaginationRequest }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.parentId = "";
        message.childId = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string parent_id */ 1:
                    message.parentId = reader.string();
                    break;
                case /* string child_id */ 2:
                    message.childId = reader.string();
                    break;
                case /* common.v1.PaginationRequest pagination */ 3:
                    message.pagination = PaginationRequest.internalBinaryRead(reader, reader.uint32(), options, message.pagination);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string parent_id = 1; */
        if (message.parentId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.parentId);
        /* string child_id = 2; */
        if (message.childId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.childId);
        /* common.v1.PaginationRequest pagination = 3; */
        if (message.pagination)
            PaginationRequest.internalBinaryWrite(message.pagination, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message sites.v1.ListCircuitNodesRequest
 */
export const ListCircuitNodesRequest = new ListCircuitNodesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListCircuitNodesResponse$Type extends MessageType {
    constructor() {
        super("sites.v1.ListCircuitNodesResponse", [
            { no: 1, name: "circuit_nodes", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => CircuitNode },
            { no: 2, name: "pagination", kind: "message", T: () => PaginationResponse }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.circuitNodes = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated sites.v1.CircuitNode circuit_nodes */ 1:
                    message.circuitNodes.push(CircuitNode.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* common.v1.PaginationResponse pagination */ 2:
                    message.pagination = PaginationResponse.internalBinaryRead(reader, reader.uint32(), options, message.pagination);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated sites.v1.CircuitNode circuit_nodes = 1; */
        for (let i = 0; i < message.circuitNodes.length; i++)
            CircuitNode.internalBinaryWrite(message.circuitNodes[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* common.v1.PaginationResponse pagination = 2; */
        if (message.pagination)
            PaginationResponse.internalBinaryWrite(message.pagination, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message sites.v1.ListCircuitNodesResponse
 */
export const ListCircuitNodesResponse = new ListCircuitNodesResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateCircuitNodeRequest$Type extends MessageType {
    constructor() {
        super("sites.v1.CreateCircuitNodeRequest", [
            { no: 1, name: "parent_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "child_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.parentId = "";
        message.childId = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string parent_id */ 1:
                    message.parentId = reader.string();
                    break;
                case /* string child_id */ 2:
                    message.childId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string parent_id = 1; */
        if (message.parentId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.parentId);
        /* string child_id = 2; */
        if (message.childId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.childId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message sites.v1.CreateCircuitNodeRequest
 */
export const CreateCircuitNodeRequest = new CreateCircuitNodeRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateCircuitNodeResponse$Type extends MessageType {
    constructor() {
        super("sites.v1.CreateCircuitNodeResponse", [
            { no: 1, name: "circuit_node", kind: "message", T: () => CircuitNode }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* sites.v1.CircuitNode circuit_node */ 1:
                    message.circuitNode = CircuitNode.internalBinaryRead(reader, reader.uint32(), options, message.circuitNode);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* sites.v1.CircuitNode circuit_node = 1; */
        if (message.circuitNode)
            CircuitNode.internalBinaryWrite(message.circuitNode, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message sites.v1.CreateCircuitNodeResponse
 */
export const CreateCircuitNodeResponse = new CreateCircuitNodeResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetCircuitNodeRequest$Type extends MessageType {
    constructor() {
        super("sites.v1.GetCircuitNodeRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message sites.v1.GetCircuitNodeRequest
 */
export const GetCircuitNodeRequest = new GetCircuitNodeRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetCircuitNodeResponse$Type extends MessageType {
    constructor() {
        super("sites.v1.GetCircuitNodeResponse", [
            { no: 1, name: "circuit_node", kind: "message", T: () => CircuitNode }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* sites.v1.CircuitNode circuit_node */ 1:
                    message.circuitNode = CircuitNode.internalBinaryRead(reader, reader.uint32(), options, message.circuitNode);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* sites.v1.CircuitNode circuit_node = 1; */
        if (message.circuitNode)
            CircuitNode.internalBinaryWrite(message.circuitNode, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message sites.v1.GetCircuitNodeResponse
 */
export const GetCircuitNodeResponse = new GetCircuitNodeResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteCircuitNodeRequest$Type extends MessageType {
    constructor() {
        super("sites.v1.DeleteCircuitNodeRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message sites.v1.DeleteCircuitNodeRequest
 */
export const DeleteCircuitNodeRequest = new DeleteCircuitNodeRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteCircuitNodeResponse$Type extends MessageType {
    constructor() {
        super("sites.v1.DeleteCircuitNodeResponse", [
            { no: 1, name: "success", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.success = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool success */ 1:
                    message.success = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool success = 1; */
        if (message.success !== false)
            writer.tag(1, WireType.Varint).bool(message.success);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message sites.v1.DeleteCircuitNodeResponse
 */
export const DeleteCircuitNodeResponse = new DeleteCircuitNodeResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListCircuitDevicesRequest$Type extends MessageType {
    constructor() {
        super("sites.v1.ListCircuitDevicesRequest", [
            { no: 1, name: "circuit_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "device_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "pagination", kind: "message", T: () => PaginationRequest }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.circuitId = "";
        message.deviceId = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string circuit_id */ 1:
                    message.circuitId = reader.string();
                    break;
                case /* string device_id */ 2:
                    message.deviceId = reader.string();
                    break;
                case /* common.v1.PaginationRequest pagination */ 3:
                    message.pagination = PaginationRequest.internalBinaryRead(reader, reader.uint32(), options, message.pagination);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string circuit_id = 1; */
        if (message.circuitId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.circuitId);
        /* string device_id = 2; */
        if (message.deviceId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.deviceId);
        /* common.v1.PaginationRequest pagination = 3; */
        if (message.pagination)
            PaginationRequest.internalBinaryWrite(message.pagination, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message sites.v1.ListCircuitDevicesRequest
 */
export const ListCircuitDevicesRequest = new ListCircuitDevicesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListCircuitDevicesResponse$Type extends MessageType {
    constructor() {
        super("sites.v1.ListCircuitDevicesResponse", [
            { no: 1, name: "circuit_devices", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => CircuitDevice },
            { no: 2, name: "pagination", kind: "message", T: () => PaginationResponse }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.circuitDevices = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated sites.v1.CircuitDevice circuit_devices */ 1:
                    message.circuitDevices.push(CircuitDevice.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* common.v1.PaginationResponse pagination */ 2:
                    message.pagination = PaginationResponse.internalBinaryRead(reader, reader.uint32(), options, message.pagination);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated sites.v1.CircuitDevice circuit_devices = 1; */
        for (let i = 0; i < message.circuitDevices.length; i++)
            CircuitDevice.internalBinaryWrite(message.circuitDevices[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* common.v1.PaginationResponse pagination = 2; */
        if (message.pagination)
            PaginationResponse.internalBinaryWrite(message.pagination, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message sites.v1.ListCircuitDevicesResponse
 */
export const ListCircuitDevicesResponse = new ListCircuitDevicesResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateCircuitDeviceRequest$Type extends MessageType {
    constructor() {
        super("sites.v1.CreateCircuitDeviceRequest", [
            { no: 1, name: "device_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "circuit_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "connected_phase", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "first_phase_position", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "priority", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.deviceId = "";
        message.circuitId = "";
        message.connectedPhase = "";
        message.firstPhasePosition = "";
        message.priority = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string device_id */ 1:
                    message.deviceId = reader.string();
                    break;
                case /* string circuit_id */ 2:
                    message.circuitId = reader.string();
                    break;
                case /* string connected_phase */ 3:
                    message.connectedPhase = reader.string();
                    break;
                case /* string first_phase_position */ 4:
                    message.firstPhasePosition = reader.string();
                    break;
                case /* int32 priority */ 5:
                    message.priority = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string device_id = 1; */
        if (message.deviceId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.deviceId);
        /* string circuit_id = 2; */
        if (message.circuitId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.circuitId);
        /* string connected_phase = 3; */
        if (message.connectedPhase !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.connectedPhase);
        /* string first_phase_position = 4; */
        if (message.firstPhasePosition !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.firstPhasePosition);
        /* int32 priority = 5; */
        if (message.priority !== 0)
            writer.tag(5, WireType.Varint).int32(message.priority);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message sites.v1.CreateCircuitDeviceRequest
 */
export const CreateCircuitDeviceRequest = new CreateCircuitDeviceRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateCircuitDeviceResponse$Type extends MessageType {
    constructor() {
        super("sites.v1.CreateCircuitDeviceResponse", [
            { no: 1, name: "circuit_device", kind: "message", T: () => CircuitDevice }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* sites.v1.CircuitDevice circuit_device */ 1:
                    message.circuitDevice = CircuitDevice.internalBinaryRead(reader, reader.uint32(), options, message.circuitDevice);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* sites.v1.CircuitDevice circuit_device = 1; */
        if (message.circuitDevice)
            CircuitDevice.internalBinaryWrite(message.circuitDevice, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message sites.v1.CreateCircuitDeviceResponse
 */
export const CreateCircuitDeviceResponse = new CreateCircuitDeviceResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetCircuitDeviceRequest$Type extends MessageType {
    constructor() {
        super("sites.v1.GetCircuitDeviceRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message sites.v1.GetCircuitDeviceRequest
 */
export const GetCircuitDeviceRequest = new GetCircuitDeviceRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetCircuitDeviceResponse$Type extends MessageType {
    constructor() {
        super("sites.v1.GetCircuitDeviceResponse", [
            { no: 1, name: "circuit_device", kind: "message", T: () => CircuitDevice }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* sites.v1.CircuitDevice circuit_device */ 1:
                    message.circuitDevice = CircuitDevice.internalBinaryRead(reader, reader.uint32(), options, message.circuitDevice);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* sites.v1.CircuitDevice circuit_device = 1; */
        if (message.circuitDevice)
            CircuitDevice.internalBinaryWrite(message.circuitDevice, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message sites.v1.GetCircuitDeviceResponse
 */
export const GetCircuitDeviceResponse = new GetCircuitDeviceResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCircuitDeviceRequest$Type extends MessageType {
    constructor() {
        super("sites.v1.UpdateCircuitDeviceRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "connected_phase", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "first_phase_position", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "priority", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "update_mask", kind: "message", T: () => FieldMask }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        message.connectedPhase = "";
        message.firstPhasePosition = "";
        message.priority = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string connected_phase */ 2:
                    message.connectedPhase = reader.string();
                    break;
                case /* string first_phase_position */ 3:
                    message.firstPhasePosition = reader.string();
                    break;
                case /* int32 priority */ 4:
                    message.priority = reader.int32();
                    break;
                case /* google.protobuf.FieldMask update_mask */ 5:
                    message.updateMask = FieldMask.internalBinaryRead(reader, reader.uint32(), options, message.updateMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string connected_phase = 2; */
        if (message.connectedPhase !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.connectedPhase);
        /* string first_phase_position = 3; */
        if (message.firstPhasePosition !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.firstPhasePosition);
        /* int32 priority = 4; */
        if (message.priority !== 0)
            writer.tag(4, WireType.Varint).int32(message.priority);
        /* google.protobuf.FieldMask update_mask = 5; */
        if (message.updateMask)
            FieldMask.internalBinaryWrite(message.updateMask, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message sites.v1.UpdateCircuitDeviceRequest
 */
export const UpdateCircuitDeviceRequest = new UpdateCircuitDeviceRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCircuitDeviceResponse$Type extends MessageType {
    constructor() {
        super("sites.v1.UpdateCircuitDeviceResponse", [
            { no: 1, name: "circuit_device", kind: "message", T: () => CircuitDevice }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* sites.v1.CircuitDevice circuit_device */ 1:
                    message.circuitDevice = CircuitDevice.internalBinaryRead(reader, reader.uint32(), options, message.circuitDevice);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* sites.v1.CircuitDevice circuit_device = 1; */
        if (message.circuitDevice)
            CircuitDevice.internalBinaryWrite(message.circuitDevice, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message sites.v1.UpdateCircuitDeviceResponse
 */
export const UpdateCircuitDeviceResponse = new UpdateCircuitDeviceResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteCircuitDeviceRequest$Type extends MessageType {
    constructor() {
        super("sites.v1.DeleteCircuitDeviceRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message sites.v1.DeleteCircuitDeviceRequest
 */
export const DeleteCircuitDeviceRequest = new DeleteCircuitDeviceRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteCircuitDeviceResponse$Type extends MessageType {
    constructor() {
        super("sites.v1.DeleteCircuitDeviceResponse", [
            { no: 1, name: "success", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.success = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool success */ 1:
                    message.success = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool success = 1; */
        if (message.success !== false)
            writer.tag(1, WireType.Varint).bool(message.success);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message sites.v1.DeleteCircuitDeviceResponse
 */
export const DeleteCircuitDeviceResponse = new DeleteCircuitDeviceResponse$Type();
/**
 * @generated ServiceType for protobuf service sites.v1.TsoService
 */
export const TsoService = new ServiceType("sites.v1.TsoService", [
    { name: "ListTsos", options: { "google.api.http": { get: "/v1/tsos" } }, I: ListTsosRequest, O: ListTsosResponse },
    { name: "CreateTso", options: { "google.api.http": { post: "/v1/tsos", body: "*" } }, I: CreateTsoRequest, O: CreateTsoResponse },
    { name: "GetTso", options: { "google.api.http": { get: "/v1/tsos/{id}" } }, I: GetTsoRequest, O: GetTsoResponse },
    { name: "UpdateTso", options: { "google.api.http": { put: "/v1/tsos/{id}", body: "*" } }, I: UpdateTsoRequest, O: UpdateTsoResponse },
    { name: "DeleteTso", options: { "google.api.http": { delete: "/v1/tsos/{id}" } }, I: DeleteTsoRequest, O: DeleteTsoResponse },
    { name: "RestoreTso", options: { "google.api.http": { post: "/v1/tsos/{id}/restore" } }, I: RestoreTsoRequest, O: RestoreTsoResponse }
]);
/**
 * @generated ServiceType for protobuf service sites.v1.DsoService
 */
export const DsoService = new ServiceType("sites.v1.DsoService", [
    { name: "ListDsos", options: {}, I: ListDsosRequest, O: ListDsosResponse },
    { name: "CreateDso", options: {}, I: CreateDsoRequest, O: CreateDsoResponse },
    { name: "GetDso", options: {}, I: GetDsoRequest, O: GetDsoResponse },
    { name: "UpdateDso", options: {}, I: UpdateDsoRequest, O: UpdateDsoResponse },
    { name: "DeleteDso", options: {}, I: DeleteDsoRequest, O: DeleteDsoResponse }
]);
/**
 * @generated ServiceType for protobuf service sites.v1.SiteService
 */
export const SiteService = new ServiceType("sites.v1.SiteService", [
    { name: "ListSites", options: { "google.api.http": { get: "/v1/sites" } }, I: ListSitesRequest, O: ListSitesResponse },
    { name: "CreateSite", options: { "google.api.http": { post: "/v1/sites", body: "*" } }, I: CreateSiteRequest, O: CreateSiteResponse },
    { name: "GetSite", options: { "google.api.http": { get: "/v1/sites/{id}" } }, I: GetSiteRequest, O: GetSiteResponse },
    { name: "UpdateSite", options: { "google.api.http": { put: "/v1/sites/{id}", body: "*" } }, I: UpdateSiteRequest, O: UpdateSiteResponse },
    { name: "DeleteSite", options: { "google.api.http": { delete: "/v1/sites/{id}" } }, I: DeleteSiteRequest, O: DeleteSiteResponse }
]);
/**
 * @generated ServiceType for protobuf service sites.v1.DeliveryPointService
 */
export const DeliveryPointService = new ServiceType("sites.v1.DeliveryPointService", [
    { name: "ListDeliveryPoints", options: {}, I: ListDeliveryPointsRequest, O: ListDeliveryPointsResponse },
    { name: "CreateDeliveryPoint", options: {}, I: CreateDeliveryPointRequest, O: CreateDeliveryPointResponse },
    { name: "GetDeliveryPoint", options: {}, I: GetDeliveryPointRequest, O: GetDeliveryPointResponse },
    { name: "UpdateDeliveryPoint", options: {}, I: UpdateDeliveryPointRequest, O: UpdateDeliveryPointResponse },
    { name: "DeleteDeliveryPoint", options: {}, I: DeleteDeliveryPointRequest, O: DeleteDeliveryPointResponse }
]);
/**
 * @generated ServiceType for protobuf service sites.v1.CircuitService
 */
export const CircuitService = new ServiceType("sites.v1.CircuitService", [
    { name: "ListCircuits", options: {}, I: ListCircuitsRequest, O: ListCircuitsResponse },
    { name: "CreateCircuit", options: {}, I: CreateCircuitRequest, O: CreateCircuitResponse },
    { name: "GetCircuit", options: {}, I: GetCircuitRequest, O: GetCircuitResponse },
    { name: "UpdateCircuit", options: {}, I: UpdateCircuitRequest, O: UpdateCircuitResponse },
    { name: "DeleteCircuit", options: {}, I: DeleteCircuitRequest, O: DeleteCircuitResponse }
]);
/**
 * @generated ServiceType for protobuf service sites.v1.CircuitNodeService
 */
export const CircuitNodeService = new ServiceType("sites.v1.CircuitNodeService", [
    { name: "ListCircuitNodes", options: {}, I: ListCircuitNodesRequest, O: ListCircuitNodesResponse },
    { name: "CreateCircuitNode", options: {}, I: CreateCircuitNodeRequest, O: CreateCircuitNodeResponse },
    { name: "GetCircuitNode", options: {}, I: GetCircuitNodeRequest, O: GetCircuitNodeResponse },
    { name: "DeleteCircuitNode", options: {}, I: DeleteCircuitNodeRequest, O: DeleteCircuitNodeResponse }
]);
/**
 * @generated ServiceType for protobuf service sites.v1.CircuitDeviceService
 */
export const CircuitDeviceService = new ServiceType("sites.v1.CircuitDeviceService", [
    { name: "ListCircuitDevices", options: {}, I: ListCircuitDevicesRequest, O: ListCircuitDevicesResponse },
    { name: "CreateCircuitDevice", options: {}, I: CreateCircuitDeviceRequest, O: CreateCircuitDeviceResponse },
    { name: "GetCircuitDevice", options: {}, I: GetCircuitDeviceRequest, O: GetCircuitDeviceResponse },
    { name: "UpdateCircuitDevice", options: {}, I: UpdateCircuitDeviceRequest, O: UpdateCircuitDeviceResponse },
    { name: "DeleteCircuitDevice", options: {}, I: DeleteCircuitDeviceRequest, O: DeleteCircuitDeviceResponse }
]);
//# sourceMappingURL=service.js.map